import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BreadcrumbItem, BreadcrumbService } from 'src/app/@core/services/breadcrumb.service';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from '../../models/item.model';

/** Unified Code breadcrumb (criterion 30): Home first, current page last and non-interactive. */
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  private destroySubject: Subject<void> = new Subject();
  items: BreadcrumbItem[] = [];
  isRtl = true;

  constructor(private breadcrumbService: BreadcrumbService, private langService: LanguageService) {}

  ngOnInit(): void {
    this.isRtl = this.langService.getCurrentLanguage() === LanguageEnum.ar;
    this.langService.languageChange
      .pipe(takeUntil(this.destroySubject))
      .subscribe((result: LanguageEnum) => (this.isRtl = result === LanguageEnum.ar));
    this.breadcrumbService.trail$
      .pipe(takeUntil(this.destroySubject))
      .subscribe((items: BreadcrumbItem[]) => (this.items = items));
  }

  dataText(item: BreadcrumbItem): string {
    return (this.isRtl ? item.textAr || item.text : item.text || item.textAr) ?? '';
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
